enum TreatmentAction {
  'MAINTAIN' = 'MAINTAIN',
  'CORRECT' = 'CORRECT',
}

export { TreatmentAction }
